/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React, { useState } from 'react';
import { FlowBlockCustomerContact as CustomerContactBlockModel } from '@staffino/model';
import {
  Box,
  Headline,
  Paragraph,
  SubmitButton,
} from '@staffino/primitive-controls';
import { useTranslation } from 'react-i18next';
import { FaCheck } from 'react-icons/fa';

type Props = {
  block: CustomerContactBlockModel;
};
const CustomerContactBlock = ({ block }: Props) => {
  const { t, i18n } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!isSubmitting) {
      setIsSubmitting(true);
      await fetch('/api/customer-contact', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        redirect: 'error',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify({
          locale: i18n.language,
          email: block.customerEmail,
          organizationId: block.organizationId,
          targetId: block.targetId,
        }),
      });
    }
  };

  return (
    <Box alignItems="center">
      <img
        src={block.image}
        width={block?.width && block?.width}
        alt="Staffino Logo"
        className="staffino-logo"
      />
      <Headline maxWidth="30rem" textAlign="center" mt={50}>
        {t(
          'Do you want to participate in other nationwide Staffino satisfaction surveys?',
        )}
      </Headline>
      <Paragraph maxWidth="30rem" textAlign="center" mt={20}>
        {t('Help us improve customer service.')}
      </Paragraph>
      <SubmitButton
        block
        maxWidth="30rem"
        width={isSubmitting && 50}
        px={isSubmitting && 0}
        my={20}
        onClick={handleSubmit}
      >
        {!isSubmitting ? t('Sign up') : <FaCheck />}
      </SubmitButton>
      {isSubmitting && (
        <Paragraph textAlign="center" mt={20} fontWeight="bold">
          {t('You have successfully entered the national satisfaction survey')}
        </Paragraph>
      )}
    </Box>
  );
};

export default CustomerContactBlock;
